// @ts-nocheck
import React from "react";
import { FC } from "react";
import { useUserAccount } from "../context";
import Admin from "./Admin";
import Agent from "./Agent";
import Parent from "./Parent";
import School from "./School";
import ServiceProvider from "./ServiceProvider";
import Student from "./Student";
import Teacher from "./Teacher";
import { UserRole } from "../../enums/UserRole";

const Content: FC = () => {
  const { user } = useUserAccount();

  switch (user.role) {
    case UserRole.Agent:
      return <Agent />;
    case UserRole.Parent:
      return <Parent />;
    case UserRole.School:
      return <School />;
    case UserRole.Student:
      return <Student />;
    case UserRole.ServiceProvider:
      return <ServiceProvider />;
    case UserRole.Teacher:
      return <Teacher />;
    default:
      return <Admin />;
  }
};

export default Content;
